var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-top-line-btn"},[_c('div',{staticClass:"table-head-btn",class:{ 'print' : _vm.ico === 'print', 'import' : _vm.ico === 'import', 'question' : _vm.ico === 'question', 'warning' : _vm.ico === 'warning'}},[_c('div',{staticClass:"table-head-btn__btn btn-style"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }